import React from 'react';
import { useParams } from 'react-router-dom';
import Loading from '../components/base/Loading';
import GenericTask from '../components/tasks/GenericTask';
import TaskView from '../components/tasks/TaskView';
import { useGetTaskQuery } from '../graphql/schema';

const Task = () => {
  const { taskId } = useParams();

  const { data, loading, refetch } = useGetTaskQuery({
    variables: {
      id: taskId ?? '',
    },
    skip: !taskId,
    // fetchPolicy: 'no-cache',
  });

  return (
    <div className="flex flex-row h-full flex-1" id="taskContainer">
      <div className="flex flex-col flex-1 bg-[#f8f8f8]">
        {loading && <Loading />}
        {!loading && !taskId && <GenericTask />}
        {data?.task && (
          <TaskView
            task={data.task}
            capability={data.capabilityForTask ?? undefined}
            taskDefinition={data.taskDefinitionForTask ?? undefined}
            reloadTask={refetch}
          />
        )}
      </div>
    </div>
  );
};

export default Task;
